import React from "react";
import Modal from "react-bootstrap/Modal";

export const MODAL_HEADER_STYLE = { backgroundColor: "#0B2166" };

export const MODAL_SUBMIT_BTN_CLASS =
  "rounded-lg border-0 px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90 disabled:opacity-60";

export const MODAL_SUBMIT_BTN_STYLE = {
  backgroundColor: "#0B2166",
  borderColor: "#0B2166",
};

export const MODAL_CANCEL_BTN_CLASS =
  "rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-600 transition hover:bg-gray-50 disabled:opacity-60";

function ProviderSettingsModal({
  show,
  title,
  onClose,
  onSubmit,
  submitLabel = "Update",
  saving = false,
  children,
}) {
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit?.(event);
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <form onSubmit={handleSubmit}>
        <Modal.Header
          closeButton={false}
          className="border-0 px-4 py-3"
          style={MODAL_HEADER_STYLE}
        >
          <Modal.Title className="text-lg font-bold text-white">{title}</Modal.Title>
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="border-0 bg-transparent text-2xl leading-none text-white transition hover:text-white/90"
            aria-label="Close"
          >
            &times;
          </button>
        </Modal.Header>

        <Modal.Body className="px-4 py-4">{children}</Modal.Body>

        <Modal.Footer className="border-t border-gray-100 px-4 py-3">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className={MODAL_CANCEL_BTN_CLASS}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={saving}
            className={MODAL_SUBMIT_BTN_CLASS}
            style={MODAL_SUBMIT_BTN_STYLE}
          >
            {saving ? "Saving..." : submitLabel}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ProviderSettingsModal;
